import { ORGANOLEPTIC_CHARACTERISTICS_ERRORS } from 'pages/qa-spec/constant';

export const ORGANOLEPTIC_CHARACTERISTICS_REQUIRED_FIELDS = {
    appearance: {
        preparationMethod: {
            message: ORGANOLEPTIC_CHARACTERISTICS_ERRORS.PREPARATION_METHOD,
        },
        specification: {
            message: ORGANOLEPTIC_CHARACTERISTICS_ERRORS.SPECIFICATION,
        },
        tolerance: {
            message: ORGANOLEPTIC_CHARACTERISTICS_ERRORS.TOLERANCE,
        },
        rejectOrFailCriteria: {
            message: ORGANOLEPTIC_CHARACTERISTICS_ERRORS.REJECT,
        },
        frequency: { message: ORGANOLEPTIC_CHARACTERISTICS_ERRORS.FREQUENCY },
        releaseCriteria: { message: ORGANOLEPTIC_CHARACTERISTICS_ERRORS.RELEASE },
    },
    color: {
        preparationMethod: {
            message: ORGANOLEPTIC_CHARACTERISTICS_ERRORS.PREPARATION_METHOD,
        },
        specification: {
            message: ORGANOLEPTIC_CHARACTERISTICS_ERRORS.SPECIFICATION,
        },
        tolerance: {
            message: ORGANOLEPTIC_CHARACTERISTICS_ERRORS.TOLERANCE,
        },
        rejectOrFailCriteria: {
            message: ORGANOLEPTIC_CHARACTERISTICS_ERRORS.REJECT,
        },
        frequency: { message: ORGANOLEPTIC_CHARACTERISTICS_ERRORS.FREQUENCY },
        releaseCriteria: { message: ORGANOLEPTIC_CHARACTERISTICS_ERRORS.RELEASE },
    },
    'aroma/odor': {
        preparationMethod: {
            message: ORGANOLEPTIC_CHARACTERISTICS_ERRORS.PREPARATION_METHOD,
        },
        specification: {
            message: ORGANOLEPTIC_CHARACTERISTICS_ERRORS.SPECIFICATION,
        },
        tolerance: {
            message: ORGANOLEPTIC_CHARACTERISTICS_ERRORS.TOLERANCE,
        },
        rejectOrFailCriteria: {
            message: ORGANOLEPTIC_CHARACTERISTICS_ERRORS.REJECT,
        },
        frequency: { message: ORGANOLEPTIC_CHARACTERISTICS_ERRORS.FREQUENCY },
        releaseCriteria: { message: ORGANOLEPTIC_CHARACTERISTICS_ERRORS.RELEASE },
    },
    'flavor/taste': {
        preparationMethod: {
            message: ORGANOLEPTIC_CHARACTERISTICS_ERRORS.PREPARATION_METHOD,
        },
        specification: {
            message: ORGANOLEPTIC_CHARACTERISTICS_ERRORS.SPECIFICATION,
        },
        rejectOrFailCriteria: {
            message: ORGANOLEPTIC_CHARACTERISTICS_ERRORS.REJECT,
        },
        tolerance: {
            message: ORGANOLEPTIC_CHARACTERISTICS_ERRORS.TOLERANCE,
        },
        frequency: { message: ORGANOLEPTIC_CHARACTERISTICS_ERRORS.FREQUENCY },
        releaseCriteria: { message: ORGANOLEPTIC_CHARACTERISTICS_ERRORS.RELEASE },
    },
    texture: {
        preparationMethod: {
            message: ORGANOLEPTIC_CHARACTERISTICS_ERRORS.PREPARATION_METHOD,
        },
        specification: {
            message: ORGANOLEPTIC_CHARACTERISTICS_ERRORS.SPECIFICATION,
        },
        rejectOrFailCriteria: {
            message: ORGANOLEPTIC_CHARACTERISTICS_ERRORS.REJECT,
        },
        tolerance: {
            message: ORGANOLEPTIC_CHARACTERISTICS_ERRORS.TOLERANCE,
        },
        frequency: { message: ORGANOLEPTIC_CHARACTERISTICS_ERRORS.FREQUENCY },
        releaseCriteria: { message: ORGANOLEPTIC_CHARACTERISTICS_ERRORS.RELEASE },
    },
    workmanship: {
        preparationMethod: {
            message: ORGANOLEPTIC_CHARACTERISTICS_ERRORS.PREPARATION_METHOD,
        },
        specification: {
            message: ORGANOLEPTIC_CHARACTERISTICS_ERRORS.SPECIFICATION,
        },
        rejectOrFailCriteria: {
            message: ORGANOLEPTIC_CHARACTERISTICS_ERRORS.REJECT,
        },
        tolerance: {
            message: ORGANOLEPTIC_CHARACTERISTICS_ERRORS.TOLERANCE,
        },
        frequency: { message: ORGANOLEPTIC_CHARACTERISTICS_ERRORS.FREQUENCY },
        releaseCriteria: { message: ORGANOLEPTIC_CHARACTERISTICS_ERRORS.RELEASE },
    },
    function: {
        preparationMethod: {
            message: ORGANOLEPTIC_CHARACTERISTICS_ERRORS.PREPARATION_METHOD,
        },
        specification: {
            message: ORGANOLEPTIC_CHARACTERISTICS_ERRORS.SPECIFICATION,
        },
        rejectOrFailCriteria: {
            message: ORGANOLEPTIC_CHARACTERISTICS_ERRORS.REJECT,
        },
        tolerance: {
            message: ORGANOLEPTIC_CHARACTERISTICS_ERRORS.TOLERANCE,
        },
        frequency: { message: ORGANOLEPTIC_CHARACTERISTICS_ERRORS.FREQUENCY },
        releaseCriteria: { message: ORGANOLEPTIC_CHARACTERISTICS_ERRORS.RELEASE },
    }
};
